import lozad from "lozad";
import { acfOnRender } from "kwp-core/scripts/utils/helpers";

export default () => {
    console.log("lozad");
    const observer = lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();

    acfOnRender(() => {
        observer.observe();
    });
};
